import React from "react";
import CapsuleImageVertical from "../../Components/CapsuleImageVertical/CapsuleImageVertical";
import SectionTwoImage1280 from "../../Assets/Images/ab-2-Male-1280-1919.png";
import SectionTwoImage1920 from "../../Assets/Images/ab-2-Male-1920.png";
import SectionTwoImageMobile from "../../Assets/Images/about-us-section-two-mobile-3.png";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

import CultureIcon1 from "../../Assets/Images/culture-icon-1.svg";
import CultureIcon2 from "../../Assets/Images/culture-icon-2.svg";
import CultureIcon3 from "../../Assets/Images/culture-icon-3.svg";
import CultureIcon4 from "../../Assets/Images/culture-icon-4.svg";
import CultureIcon5 from "../../Assets/Images/culture-icon-5.svg";
import CultureIcon6 from "../../Assets/Images/culture-icon-6.svg";

const Great = () => {
  const translations = useTranslation(); // Get translations dynamically
  const awards = [
    {
      icon: CultureIcon6,
      title: translations.cultureFeatureOne,
    },
    {
      icon: CultureIcon1,
      title: translations.cultureFeatureTwo,
    },
    {
      icon: CultureIcon2,
      title: translations.cultureFeatureThree,
    },
    {
      icon: CultureIcon5,
      title: translations.cultureFeatureFour,
    },
    {
      icon: CultureIcon4,
      title: translations.cultureFeatureFive,
    },
  ];
  return (
    <>
      <div className="flex-1">
        {/* Desktop 1280-1919 */}
        <div className="hidden lg:block [@media(min-width:1920px)]:hidden">
          <CapsuleImageVertical image={SectionTwoImage1280} />
        </div>
        {/* Desktop 1920+ */}
        <div className="hidden [@media(min-width:1920px)]:block">
          <CapsuleImageVertical image={SectionTwoImage1920} />
        </div>
      </div>

      <div className="flex-1 mt-2 lg:mt-6 flex-wrap gap-4 reveal-up lg:pl-0 px-4">
        <div className="grid grid-cols-2">
          {awards.map((award, index) => (
            <div key={index} className="py-4 px-2 rounded-lg">
              <div className="w-[60px] h-[60px] lg:bg-[#F7F6F2] bg-[#F7F6F2] rounded-2xl flex justify-center items-center">
                <img
                  src={award.icon}
                  alt=""
                  className="flex-shrink-0 inline-flex"
                />
              </div>
              <div className="text-sm md:text-[11.5px] md:leading-[18px] xl:text-sm xl:leading-normal mt-2">
                <p
                  className="font-medium extra-para-vs"
                  dangerouslySetInnerHTML={{ __html: award.title }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Great;
